import React from 'react';

// Shared presentational tier-input row (4 boxes, T1-T4). Controlled and
// behaviour-free: the parent's onSet decides clamping/balancing. Defined at module
// level so rows don't remount (and lose focus) on every render.
// showTierLabels puts the T1-T4 caption on each box, for layouts with no column
// header to carry it; callers that draw their own caption row leave it off.
function TierInputs({ values, onSet, disabled = false, showTierLabels = false }) {
  return (
    <div className='mie-tiers'>
      {values.map((tierValue, tier) => (
        <div
          key={tier}
          className='mie-tier'
        >
          {showTierLabels && <span className='mie-tier-lbl'>{`T${tier + 1}`}</span>}
          <input
            className='mie-num'
            type='number'
            min='0'
            max='100'
            value={tierValue}
            disabled={disabled}
            onChange={(e) => onSet(tier, e.target.value)}
            aria-label={`Tier ${tier + 1}`}
          />
        </div>
      ))}
    </div>
  );
}

export default TierInputs;
